import { createApp } from 'vue'
import App from './views/mobile/App.vue'
import router from './router/index_mobile'
import store from './store'
import Vant from 'vant';
import axiosInit from './network/axios-init';
import plugin from './utils/plugin'
import 'vant/lib/index.css';
import 'assets/font/iconfont/iconfont.css'
import 'assets/css/normalize.css'
import 'assets/css/common_mobile.scss'
import storage from "./utils/storage";

const app = createApp(App)

app.config.globalProperties.$http = axiosInit()
storage.sessionSet('platform', 'mobile')


app.use(store)
app.use(router)
app.use(Vant)
app.use(plugin)

app.mount('#app')
